import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { UserRole } from '../types/user';

interface RequireAdminProps {
    redirectTo?: string;
}

export const RequireAdmin = ({ redirectTo = '/dashboard' }: RequireAdminProps) => {
    const location = useLocation();
    const isAuthenticated = useSelector((state: RootState) => !!state.user.jwtToken);
    const role = useSelector((state: RootState) => state.user.role) as UserRole | undefined;

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location.pathname }} />;
    }

    return role === UserRole.ADMIN ? <Outlet /> : <Navigate to={redirectTo} replace />;
};


